// Versão: 1.01
// Data..: 2026-09-24
// Cabeçalho de página padronizado (eyebrow + título + descrição + ações à direita).

import type { ReactNode } from 'react';

export function PageHeader({
  title,
  description,
  eyebrow,
  actions,
}: {
  title: string;
  description?: string;
  eyebrow?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="page-header">
      <div>
        {eyebrow && <div className="ph-eyebrow">◆ {eyebrow}</div>}
        <h1 className="ph-title">{title}</h1>
        {description && <p className="ph-desc">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}
